import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { TCAAngularCoreComponent } from './tca-angular-core.component';
import { AutofocusDirective } from './common/auto-focus.directive';
import { InputRefDirective } from './common/input-ref.directive';
import { IconInputComponent } from './icon-input/icon-input.component';
import { LabelSelectComponent } from './label-select/label-select.component';
import { WizardComponent } from './wizard/wizard.component';
import { ToggleComponent } from './toggle/toggle.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { DndUploadComponent } from './dnd-upload/dnd-upload.component';
import { DndUploadDirective } from './common/dnd-upload.directive';
import { InputButtonComponent } from './input-button/input-button.component';
import { TextToggleComponent } from './text-toggle/text-toggle.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ToastComponent } from './toast/toast.component';
import { ToastService } from './toast/toast.service';
import { OverlayModule, OVERLAY_PROVIDERS } from '@angular/cdk/overlay';
import { TruncatePipe } from './common/truncate.pipe';

@NgModule({
  declarations: [
    TCAAngularCoreComponent,
    IconInputComponent,
    LabelSelectComponent,
    InputRefDirective,
    AutofocusDirective,
    WizardComponent,
    ToggleComponent,
    DropdownComponent,
    DndUploadComponent,
    DndUploadDirective,
    InputButtonComponent,
    TextToggleComponent,
    PaginationComponent,
    TruncatePipe,
    ToastComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ScrollingModule,
    FormsModule
  ],
  providers: [
    OVERLAY_PROVIDERS
  ],
  exports: [
    TCAAngularCoreComponent,
    IconInputComponent,
    LabelSelectComponent,
    InputRefDirective,
    WizardComponent,
    ToggleComponent,
    DropdownComponent,
    DndUploadComponent,
    InputButtonComponent,
    TextToggleComponent,
    PaginationComponent,
    ToastComponent
  ],
  entryComponents: [
    ToastComponent
  ]
})
export class TCAAngularCoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: TCAAngularCoreModule,
            providers: [ ToastService ]
        };
    }
}
